import { render } from "./RouterTab.vue?vue&type=template&id=0b48061e&scoped=true"
import script from "./RouterTab.vue?vue&type=script&lang=js"
export * from "./RouterTab.vue?vue&type=script&lang=js"

import "./RouterTab.vue?vue&type=style&index=0&id=0b48061e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b48061e"]])

export default __exports__